import axios from "axios";

const UPDATE_NPS_BY_ID_URL = "https://api-weretail-store.azurewebsites.net/api/UpdateNPSByID";
const LEGACY_UPDATE_URL = "https://us-central1-hackretail-92ffa.cloudfunctions.net/setNPSInfo";

const coerceAnswer = (answer) => (typeof answer === "string" ? answer : JSON.stringify(answer));

async function setNPSAnswerAPI(shortcode, answerPayload, legacyFallback) {
    const options = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
    };

    if (shortcode) {
        const url = new URL(UPDATE_NPS_BY_ID_URL);
        url.searchParams.set("code", "s4ythslAldgtUm46OMEVR-p-Rf5iJNjuvmCM3YQFLXHqAzFuzQbG6w==");
        url.searchParams.set("shortcode", shortcode);

        const data = {
            shortcode,
            answer: coerceAnswer(answerPayload),
        };
        return axios.post(url.toString(), data, options);
    }

    // Backward compatibility for old flow (used only if shortcode is missing)
    const legacyData = {
        or: legacyFallback?.organization,
        npsId: legacyFallback?.npsId,
        npsGeneral: legacyFallback?.npsGeneral,
        npsSeller: legacyFallback?.npsSeller,
        howToImprove: legacyFallback?.howToImprove,
        npsProduct: legacyFallback?.npsProduct,
    };
    return axios.post(LEGACY_UPDATE_URL, legacyData, options);
}

export default setNPSAnswerAPI;
